import React from 'react'
import ClassNames from 'classnames'
import { SourcingProjectsStyled } from './styled'
import { pageSourcingBuyerDetailFormController } from '../../middleware'
import moment from 'moment'
import {
  Button,
  Modal,
  Image,
  InputSearch,
  Paginate,
  Section,
  SelectBox,
  Table,
  Input,
  Text,
  DatePickerInput,
  Breadcrumbs,
  Spinner,
} from '../../components'
import { ICONS } from '../../themes'
import { isEmpty } from 'lodash'
import {
  filterSearchSourcingInput1,
  filterSearchSourcingOptions2,
  filterSearchSourcingOptions3,
  filterSearchSourcingOptions4,
  filterSearchSourcingOptions5,
  startApiRequestUnseal,
  startApiRequestUnsealTec,
  filterDateFrom,
  filterDateTo,
  filterStatusSourcingProjects,
  filterPage,
  searchEventListSearch,
  searchEventListAllStatus,
  searchEventListSealStatus,
  searchEventListAllEventType,
  searchEventListAllAward,
  searchEventListAllUser,
} from '../../store/actions'
import { eventNewController, rfqController } from '../../apiService'
import {
  ROUTE_PATH,
  STRING,
  toastActive,
  toastFail,
  funcCheckStatusProject,
  localStorageService,
} from '../../helpers'
import {
  dateMonDayYearTime,
  formatNumberWithComma,
} from '../../helpers/functions/format'
import FileDownload from 'js-file-download'
import { store } from 'store'
import { connect } from 'react-redux'
import NumberFormat from 'react-number-format'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { map, find } from 'lodash'
const optionsSealStatus = [
  { value: 0, label: 'All Seal Status' },
  { value: 2, label: 'Awaiting Unseal' },
  { value: 3, label: 'Unsealed' },
  { value: 1, label: 'Sealed' },
  { value: 10, label: '-' },
]
export class SourcingProjectsContainers extends React.Component {
  _isMounted = false
  constructor(props) {
    super(props)
    this.state = {
      modals: [
        { name: 'history', isOpen: false },
        {
          name: 'delete',
          isOpen: false,
          FullName: '',
          sourcing_id: '',
        },
      ],
      resultRFQ: {
        page: 1,
        limit: 10,
      },
      statuses: [],
      buyerList: [],
      awardStatuses: [],
      sealStatus: optionsSealStatus,
      eventTypes: [],
      listRFQ: [],
      eventName: '',
      buyerId: 0,
      awardId: 0,
      statusId: 0,
      searchPage: 1,
      activePage: 1,
      searchValue: '',
      projectListHistoies: [],
      isMoreOptionPanelOpen: false,
      startDate: '',
      endDate: '',
      disabledDateTo: true,
      isErrMsgEndDate: '',
      isErrMsgStartDate: '',
      optionsProjectStatus: '',
      editRoleDetail: null,
      loaderHistory: false,
    }
    this.listDelete = ''
  }
  toggleModal = (evt, name, sourcing_id) => {
    this.setState(prevState => ({
      ...prevState,
      modals: prevState.modals.map(modal => ({
        ...modal,
        isOpen: modal.name === evt ? !modal.isOpen : false,
        FullName: name,
        sourcing_id: sourcing_id,
      })),
    }))
  }
  static getDerivedStateFromProps(props, state) {
    let params = props.location.state
    if (params) {
      if (params.status) {
        const paramStatus = parseInt(params.status)
        store.dispatch(filterSearchSourcingOptions2(paramStatus, true))
      } else if (params.awaitingunseal) {
        const paramAwaitingUnseal = parseInt(params.awaitingunseal)
        store.dispatch(filterSearchSourcingOptions5(paramAwaitingUnseal, true))
      } else {
        const paramAward = parseInt(params.award)
        store.dispatch(filterSearchSourcingOptions3(paramAward, true))
      }
    }
    return null
  }
  componentDidMount() {
    this._isMounted = true
    const {
      dateFrom,
      dateTo,
      page,
      enterSearchSourcingFilter,
      selectedSourcingOptions2,
      selectedSourcingOptions3,
      selectedOptionsSourcing4,
      selectedOptionsSourcing5,
      filterStatus,
    } = this.props
    localStorage.setItem('isFromDetail', false)
    store.dispatch(searchEventListSearch())
    store.dispatch(searchEventListAllStatus())
    store.dispatch(searchEventListSealStatus())
    store.dispatch(searchEventListAllEventType())
    store.dispatch(searchEventListAllAward())
    store.dispatch(searchEventListAllUser())
    this.funcGetOptionsProjectStatus()
    const notifyRequestUnseal = () => {
      const { messageReqUnseal } = this.props
      if (messageReqUnseal) {
        return toast.success(messageReqUnseal, {
          onClose: () => {
            store.dispatch(startApiRequestUnseal())
          },
        })
      }
    }
    const notifyRequestUnsealTec = () => {
      const { messageReqUnsealTec } = this.props
      if (messageReqUnsealTec) {
        if (messageReqUnsealTec === 'Cannot unseal by this user') {
          return toast.error(messageReqUnsealTec, {
            onClose: () => {
              store.dispatch(startApiRequestUnsealTec())
            },
          })
        } else if (messageReqUnsealTec === 'Event not ready to unseal') {
          return toast.error(messageReqUnsealTec, {
            onClose: () => {
              store.dispatch(startApiRequestUnsealTec())
            },
          })
        } else if (messageReqUnsealTec === 'Unsealed by Other TEC') {
          return toast.error(messageReqUnsealTec, {
            onClose: () => {
              store.dispatch(startApiRequestUnsealTec())
            },
          })
        } else {
          return toast.success(messageReqUnsealTec, {
            onClose: () => {
              store.dispatch(startApiRequestUnsealTec())
            },
          })
        }
      }
    }
    notifyRequestUnseal()
    notifyRequestUnsealTec()
    this.setState({
      startDate: dateFrom,
      endDate: dateTo,
      activePage: page,
    })
    if (
      enterSearchSourcingFilter ||
      selectedSourcingOptions2 ||
      selectedSourcingOptions3 ||
      selectedOptionsSourcing4 ||
      selectedOptionsSourcing5 ||
      dateFrom ||
      dateTo ||
      page ||
      filterStatus
    ) {
      this.getListRFQ(page)
    } else {
      const params = this.props.location.state
      if (params) {
        if (params.status) {
          this.getListRFQDefault(params.status, 0)
        } else if (params.awaitingunseal) {
          this.getListRFQDefault(0, 0, params.awaitingunseal)
        } else {
          this.getListRFQDefault(0, params.award)
        }
      } else {
        this.getListRFQDefault(0, 0)
      }
    }
    this.getEventStatus()
    this.getEventAwardStatus()
    this.getRFQBuyerList()
    this.getEventTypes()
    this.funcCheckRoles()
  }
  funcGetOptionsProjectStatus = async () => {
    const res = await rfqController().getSourcingprojectStatus()
    if (res) {
      let mapArray = map(res, (v, k) => {
        return {
          value: v.id,
          label: v.name,
        }
      })
      return this.setState({ optionsProjectStatus: mapArray })
    }
  }
  funcCheckRoles(user = '') {
    let { editRoleDetail } = this.state
    const resUserName = localStorageService.getUsersName()
    const roles = pageSourcingBuyerDetailFormController().asset(
      resUserName,
      user
    )
    const { edit } = roles
    editRoleDetail = edit
    this.setState({ editRoleDetail })
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      prevState.startDate !== this.state.startDate ||
      prevState.endDate !== this.state.endDate
    ) {
      const { startDate, endDate } = this.state
      if (startDate === '' && endDate === '') {
        // all
        return this.getListRFQ()
      } else if (startDate && endDate) {
        // date from date to
        return this.getListRFQ()
      } else if (startDate) {
        // start date
        return this.getListRFQ()
      } else if (endDate) {
        // date to
        return this.getListRFQ()
      }
    }
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  getEventStatus = async () => {
    const res = await eventNewController().getEventStatus()
    if (res) {
      let option = []
      res.map(e => {
        const data = {
          value: parseInt(e.id),
          label: e.name,
        }
        option.push(data)
      })
      this.setState({ statuses: option })
    }
  }
  getRFQBuyerList = async () => {
    const res = await rfqController().getBuyerList()
    if (res) {
      let option = []
      res.map(e => {
        const data = {
          value: parseInt(e.id),
          label: e.full_name,
        }
        option.push(data)
      })
      this.setState({ buyerList: option })
    }
  }

  getEventAwardStatus = async () => {
    const res = await eventNewController().getEventAwardStatus()
    if (res) {
      let option = []
      res.map(e => {
        const data = {
          value: parseInt(e.id),
          label: e.name,
        }
        option.push(data)
      })
      this.setState({ awardStatuses: option })
    }
  }
  getEventTypes = async () => {
    const res = await rfqController().getEventTypes()
    if (res) {
      let option = []
      res.map(e => {
        const data = { value: e.ID, label: e.name }
        option.push(data)
      })
      this.setState({ eventTypes: option })
    }
  }

  getListRFQ = async page => {
    const { resultRFQ } = this.state
    let setDateTo
    if (this.props.dateTo) {
      setDateTo = new Date(this.props.dateTo)
      setDateTo.setHours(23, 59, 59, 999)
    }

    const params = {
      limit: resultRFQ.limit,
      page: page ? page : resultRFQ.page,
      createById: this.props.searchOptionSourcingFilter4,
      eventName: this.props.searchSourcingInput.trim(),
      statusId: this.props.filterStatus,
      createdDateForm: this.props.dateFrom
        ? this.props.dateFrom.toISOString()
        : '0001-01-01T00:00:00Z',
      createdDateTo: setDateTo
        ? setDateTo.toISOString()
        : '0001-01-01T00:00:00Z',
      // createdDateForm: ,
      // createdDateTo: this.props.dateTo,
    }

    const res = await rfqController().getListRFQ(params)
    if (res) {
      // const filterSuppliersIsCancel = this.filterSupplierListStatusCancel(
      //   res.records,
      //   statusId
      // )
      store.dispatch(filterPage(page ? page : resultRFQ.page, true))
      this.setState({
        resultRFQ: res,
        listRFQ: res.records,

        activePage: page ? page : resultRFQ.page,
      })
    } else {
      toastFail('error', res)
    }
  }
  getListRFQDefault = async status => {
    const { resultRFQ, eventName, awardId, statusId, buyerId } = this.state
    const params = {
      limit: resultRFQ.limit,
      page: resultRFQ.page,
      createById: buyerId,
      eventName: '',
      statusId: status,
      createdDateForm: '0001-01-01T00:00:00Z',
      createdDateTo: '0001-01-01T00:00:00Z',
    }
    const res = await rfqController().getListRFQ(params)
    if (res) {
      // const filterSuppliersIsCancel = this.filterSupplierListStatusCancel(
      //   res.records,
      //   statusId
      // )
      this.setState({
        resultRFQ: res,
        listRFQ: res.records,
      })
    } else {
      toastFail('error')
    }
  }
  filterSupplierListStatusCancel = (suppliers = [], statusId = '') => {
    const filterIsCancel = suppliers.filter(data => {
      const eventCancel = data.is_cancel && (statusId === 5 || statusId === 0)
      const eventNotCancel = !data.is_cancel && statusId !== 5
      if (eventCancel) {
        return data
      } else if (eventNotCancel) {
        return data
      }
    })
    return filterIsCancel
  }

  onClickDelete = async id => {
    try {
      const res = await rfqController().deleteSourcingProject(id)
      if (res === '52007: sourcing project is not draft') {
        toastFail('Sourcing Project  is not draft')
        this.toggleModal()
      } else if (
        res === '52013: user do not have permission to delete sourcing project'
      ) {
        toastFail('User do not have permission to delete sourcing project')
        this.toggleModal()
      } else {
        this.getListRFQ()
        toastActive('Sourcing Project was delete')
        this.toggleModal()
      }
    } catch (error) {
      this.toggleModal()
    }
  }

  matchValueSelected = (option, selectedId) => {
    let result = find(
      option,
      (v, k) => v.value.toString() === selectedId.toString()
    )
    return result
  }

  matchValue = (option, selectedId) => {
    if (option.length !== 0) {
      const matchOption = option.find(
        value => value.value.toString() === selectedId.toString()
      )
      if (matchOption) {
        return matchOption.label
      }
    }
  }
  matchValueSealStatus = (option, selectedLabel) => {
    const matchOption = option.find(value => value.label === selectedLabel)
    if (matchOption) {
      return matchOption.label
    }
  }
  renderSealStatusText = (options, values) => {
    const objectText = {
      awaiting: 'Awaiting Unseal',
      unsealed: 'Unsealed',
      sealed: 'Sealed',
    }
    if (values) {
      if (values === objectText.awaiting) {
        return (
          <React.Fragment>
            <p className="seal-status-awaiting">
              {this.matchValueSealStatus(options, values)}
            </p>
          </React.Fragment>
        )
      } else if (values === objectText.unsealed) {
        return (
          <React.Fragment>
            <p className="seal-status-unsealed">
              {this.matchValueSealStatus(options, values)}
            </p>
          </React.Fragment>
        )
      } else if (values === objectText.sealed) {
        return (
          <React.Fragment>
            <p className="seal-status-sealed">
              {this.matchValueSealStatus(options, values)}
            </p>
          </React.Fragment>
        )
      }
    } else {
      return '-'
    }
  }
  changePage = e => {
    this.getListRFQ(e)
    this.setState({ activePage: e })
  }

  // copyRfqByID = async (id = '') => {
  //   try {
  //     if (id) {
  //       const res = await rfqController().copyRfqByID(id)
  //       if (res) {
  //         const rfqCopyID = res
  //         this.props.history.push({
  //           pathname: ROUTE_PATH.RFQ_COPY_DETAIL.LINK,
  //           state: rfqCopyID,
  //         })
  //       }
  //     } else {
  //       throw 'rfq id not found'
  //     }
  //   } catch (error) {
  //     throw `copy rfq fail ${error}`
  //   }
  // }

  getProjectHistoriesByProjectID = async (projectID = '') => {
    this.setState({ loaderHistory: true })
    try {
      if (projectID) {
        const res = await rfqController().projectListHistories(projectID)
        if (res) {
          this.setState({
            projectListHistoies: res,
            loaderHistory: false,
          })
        }
      }
    } catch (error) {
      throw error
    }
  }

  downloadCompareToExcel = info => {
    return rfqController()
      .downloadCompareToExcel(info.sourcing_id)
      .then(res => FileDownload(res.data, info.sourcing_name + '.xlsx'))
  }

  onClickOpenRfqHistory = e => {
    const { id } = e
    this.getProjectHistoriesByProjectID(id)
    this.toggleModal('history', e.sourcing_name, e.sourcing_id)
  }

  onCloseModalHistory = () => {
    this.toggleModal()
    this.setState({ rfqHistories: [] })
  }

  listRole = (roles = []) => {
    if (roles.length > 0) {
      return (
        <React.Fragment>
          <div>
            {roles.map((v, i) => {
              return <p key={v.id}>{v.name}</p>
            })}
          </div>
        </React.Fragment>
      )
    }
  }

  renderStartDateEndDate = (date = {}) => {
    return (
      <Section>
        ( Start date: {dateMonDayYearTime(date.start_date)}
        <br />
        End date: {dateMonDayYearTime(date.end_date)} )
      </Section>
    )
  }

  rfqHistoryReopenRescheduleShowStartDateEndDate = (rh = {}) => {
    const reOpen = rh.action_history_type_id === 11
    const reSchedule = rh.action_history_type_id === 12

    if (reOpen || reSchedule) {
      const date = {
        start_date: rh.start_date,
        end_date: rh.end_date,
      }
      return this.renderStartDateEndDate(date)
    }
  }

  renderProjectHistories = (rfqHistories = []) => {
    return rfqHistories.map((rh, i) => {
      const reject = rh.action_history_type_id === 9
      const isSupplierAccount = rh.by_main_role_id === 3
      return (
        <Table.TR key={i}>
          <Table.TD className="create-date">
            {dateMonDayYearTime(rh.created_at)}
          </Table.TD>

          <Table.TD className="detail">
            <Section>{rh.action_history_type}</Section>
            {/* {reject && <Section>Reason {rh.cancel_reason}</Section>}
            {this.rfqHistoryReopenRescheduleShowStartDateEndDate(rh)} */}
          </Table.TD>

          <Table.TD className="action">
            <Section> {rh.action_by}</Section>
            <Section>
              {this.listRole(rh.roles)}
              {/* {isSupplierAccount
                ? rh.supplier_company_name
                : this.listRole(rh.roles)} */}
            </Section>
          </Table.TD>
        </Table.TR>
      )
    })
  }

  onClickClearSearch = () => {
    const DEFAULT_PAGE = 1
    store.dispatch(filterSearchSourcingInput1(''))
    this.setState({ activePage: DEFAULT_PAGE }, () => {
      this.getListRFQ(DEFAULT_PAGE)
    })
  }
  renderIconExport = (data, rolesTec) => {
    if (
      data.sourcing_seal_status !== '' &&
      data.sourcing_status === 4 &&
      data.sourcing_seal_status !== 'Awaiting Unseal' &&
      data.sourcing_seal_status !== 'Sealed'
    ) {
      return (
        <React.Fragment>
          {rolesTec !== false && (
            <Button
              className="link"
              onClick={() => {
                this.downloadCompareToExcel(data)
              }}
            >
              <Image
                className="export-icon"
                src={ICONS['icon-export.svg']}
                alt="export"
                tootipValue={`Export`}
                useTootipFor="Export"
                useTootip={true}
              />
            </Button>
          )}
        </React.Fragment>
      )
    } else if (
      data.sourcing_seal_status !== '' &&
      data.sourcing_status === 5 &&
      data.sourcing_seal_status !== 'Awaiting Unseal' &&
      data.sourcing_seal_status !== 'Sealed'
    ) {
      return (
        <React.Fragment>
          {rolesTec !== false && (
            <Button
              className="link"
              onClick={() => {
                this.downloadCompareToExcel(data)
              }}
            >
              <Image
                className="export-icon"
                src={ICONS['icon-export.svg']}
                alt="export"
                tootipValue={`Export`}
                useTootipFor="Export"
                useTootip={true}
              />
            </Button>
          )}
        </React.Fragment>
      )
    } else if (data.sourcing_seal_status == '' && data.sourcing_status === 4) {
      return (
        <React.Fragment>
          {rolesTec !== false && (
            <Button
              className="link"
              onClick={() => {
                this.downloadCompareToExcel(data)
              }}
            >
              <Image
                className="export-icon"
                src={ICONS['icon-export.svg']}
                alt="export"
                tootipValue={`Export`}
                useTootipFor="Export"
                useTootip={true}
              />
            </Button>
          )}
        </React.Fragment>
      )
    } else if (data.sourcing_seal_status == '' && data.sourcing_status === 5) {
      return (
        <React.Fragment>
          {rolesTec !== false && (
            <Button
              className="link"
              onClick={() => {
                this.downloadCompareToExcel(data)
              }}
            >
              <Image
                className="export-icon"
                src={ICONS['icon-export.svg']}
                alt="export"
                tootipValue={`Export`}
                useTootipFor="Export"
                useTootip={true}
              />
            </Button>
          )}
        </React.Fragment>
      )
    } else if (data.sourcing_seal_status == '' && data.is_cancel === true) {
      return (
        <React.Fragment>
          {rolesTec !== false && (
            <Button
              className="link"
              onClick={() => {
                this.downloadCompareToExcel(data)
              }}
            >
              <Image
                className="export-icon"
                src={ICONS['icon-export.svg']}
                alt="export"
                tootipValue={`Export`}
                useTootipFor="Export"
                useTootip={true}
              />
            </Button>
          )}
        </React.Fragment>
      )
    }
  }
  renderSourcingList = () => {
    const {
      modals,
      resultRFQ,
      activePage,
      listRFQ,
      eventName,
      statuses,
      buyerList,
      awardStatuses,
      eventTypes,
      buyerId,
      statusId,
      awardId,
      sealStatus,
      isMoreOptionPanelOpen,
    } = this.state
    const idRoleTec = 10
    const someArrayCheckRole = element => {
      return element.id !== idRoleTec
    }
    let hideTecRole = null
    const isEmpty = obj => {
      if (typeof obj == 'number') return false
      else if (typeof obj == 'string') return obj.length == 0
      else if (Array.isArray(obj)) return obj.length == 0
      else if (typeof obj == 'object')
        return obj == null || Object.keys(obj).length == 0
      else if (typeof obj == 'boolean') return false
      else return !obj
    }
    const checkEmptyRole = isEmpty(this.props.user)
    if (checkEmptyRole === false && this.props.user.roles) {
      hideTecRole = this.props.user.roles.some(someArrayCheckRole)
    }
    const pageTitle = () => {
      const funchideTecRole = () => {
        const handlerClickViewAllEvent = e => {
          if (e.detail === 1) {
            store.dispatch(filterPage(1, true))
            return this.props.history.push(ROUTE_PATH.SOURCING_BUYER.LINK)
          }
        }
        const handlerClickCreateProject = e => {
          if (e.detail === 1) {
            return this.props.history.push(
              ROUTE_PATH.SOURCING_DETAIL_BUYER_FORM.LINK
            )
          }
        }
        return (
          <Section className="page-button">
            <Button
              className="page-button theme-border"
              onClick={handlerClickViewAllEvent}
            >
              View All Event
            </Button>
            {this.state.editRoleDetail && (
              <Button
                className="page-button"
                onClick={handlerClickCreateProject}
              >
                Create Project
              </Button>
            )}
          </Section>
        )
      }
      return (
        <Section className="page-topbar">
          <Section className="page-header">
            <Section className="page-icon">
              <Image
                id="page_icon_user_management"
                src={ICONS['icon-sourcing-white.svg']}
                alt="page icon"
              />
            </Section>
            <Section className="title-and-breadcrumb">
              <Section id="page_title_user_management" className="title">
                Sourcing
              </Section>
              <Breadcrumbs props={this.props} />
            </Section>
          </Section>
          {funchideTecRole()}
        </Section>
      )
    }
    const renderPageContent = () => {
      const funcOnKeyDownSearchInput = e => {
        if (e.keyCode == 13) {
          this.getListRFQ(1)
          return store.dispatch(
            filterSearchSourcingInput1(e.target.value, true)
          )
        }
      }
      const funcOnChangeSearchInput = e => {
        return store.dispatch(filterSearchSourcingInput1(e.target.value))
      }
      const funconClickSearchSearchInput = e => {
        return this.onClickClearSearch()
      }
      const funcOnChangeEventStatusFilter = event => {
        resultRFQ.page = 1
        store.dispatch(filterStatusSourcingProjects(event.value, true))
        return this.setState({ resultRFQ }, this.getListRFQ)
      }
      const funcOnChangeCreateStatusFilter = event => {
        resultRFQ.page = 1
        store.dispatch(filterSearchSourcingOptions4(event.value, true))
        return this.setState({ resultRFQ }, this.getListRFQ)
      }
      const funcListRFQ = () => {
        const { editRoleDetail } = this.state
        if (listRFQ) {
          const funcStartDate = e => {
            if (e.created_at === '0001-01-01T00:00:00Z') {
              return 'N/A'
            } else {
              const setTimeCreatedDate = e.created_at
                ? moment(e.created_at, 'YYYY/MM/DD HH:mm:ss').toDate()
                : null
              return dateMonDayYearTime(setTimeCreatedDate)
              // return dateMonDayYearTime(e.created_at)
            }
          }
          const funcActiveStatus = e => {
            const { optionsProjectStatus } = this.state
            if (e.is_cancel) {
              return <p className={`info-status`}>Cancelled</p>
            } else {
              if (e.project_status_id) {
                return (
                  <p
                    className={
                      e.project_status_id === 1 || e.project_status_id === 2
                        ? `pending-status`
                        : e.project_status_id === 3
                        ? `success-status`
                        : `success-status`
                    }
                  >
                    {this.matchValue(optionsProjectStatus, e.project_status_id)}
                  </p>
                )
              } else {
                return null
              }
            }
          }
          const actionsEdit = e => {
            const { project_status_id, id, draft_event_id } = e
            const linkCreateProjectDetail = `/sourcing-detail-form-buyer/${id}`
            const linkCreateProjectDetailDraft = `/sourcing-detail-form-buyer/${id}/${draft_event_id}`
            const statusDraft = 'Draft'
            const resStatus = funcCheckStatusProject(project_status_id)
            const handlerClick = e => {
              if (draft_event_id) {
                return this.props.history.push(linkCreateProjectDetailDraft)
              } else {
                return this.props.history.push(linkCreateProjectDetail)
              }
            }
            if (resStatus === statusDraft) {
              return (
                <Button className="link" onClick={handlerClick}>
                  <Image
                    className="edit-icon"
                    src={ICONS['icon-edit.svg']}
                    alt="edit"
                    tootipValue={`View/Edit`}
                    useTootipFor="Edit"
                    useTootip={true}
                  />
                </Button>
              )
            } else {
              return ''
            }
          }
          const actionscompareEvent = e => {
            if (e.sourcing_status !== 1) {
              return (
                <Button
                  className="link"
                  onClick={() => {
                    this.props.history.push('/sourcing-compare-event/' + e.id)
                  }}
                >
                  <Image
                    className="compare-icon"
                    src={ICONS['icon-compare.svg']}
                    alt="compare"
                    tootipValue={`Compare`}
                    useTootipFor="Compare"
                    useTootip={true}
                  />
                </Button>
              )
            }
          }
          // const funcCopyRfqByID = e => {
          //   if (hideTecRole !== false) {
          //     return (
          //       <Button
          //         className="link"
          //         onClick={() => {
          //           this.copyRfqByID(e.id)
          //         }}
          //       >
          //         <Image
          //           className="paste-icon"
          //           src={ICONS['icon-paste.svg']}
          //           alt="copy"
          //           tootipValue={`Copy`}
          //           useTootipFor="Copy"
          //           useTootip={true}
          //         />
          //       </Button>
          //     )
          //   }
          // }
          const handlerActionsLinkClick = e => {
            return this.onClickOpenRfqHistory(e)
          }
          const funcDelete = e => {
            if (e.project_status_id === 1 && hideTecRole !== false) {
              return (
                <Button
                  className="link"
                  onClick={() => {
                    this.toggleModal('delete', e.name, e.id),
                      (this.listDelete = e.id)
                    document.body.classList.add('modal-open')
                  }}
                >
                  <Image
                    className="delete-icon"
                    src={ICONS['icon-trash.svg']}
                    alt="delete"
                    tootipValue={`Delete`}
                    useTootipFor="Delete"
                    useTootip={true}
                  />
                </Button>
              )
            }
          }
          const renderHistoryButton = e => {
            return (
              <Button
                className="link"
                onClick={() => {
                  handlerActionsLinkClick(e)
                }}
              >
                <Image
                  className="history-icon"
                  src={ICONS['icon-history.svg']}
                  alt="history"
                  tootipValue={`History`}
                  useTootipFor="History"
                  useTootip={true}
                />
              </Button>
            )
          }
          const renderSchematicButton = e => {
            const { project_status_id, id } = e
            const { history } = this.props
            const linkProjectDetail = `/sourcing-project-detail/${id}`
            const statusWip = 'WIP'
            const statusCancelled = 'Cancelled'
            const statusCompleted = 'Completed'
            const resStatusWip = funcCheckStatusProject(project_status_id)
            const resStatusCancelled = funcCheckStatusProject(project_status_id)
            const resStatusCompleted = funcCheckStatusProject(project_status_id)
            const handlerClick = () => {
              return history.push(linkProjectDetail)
            }
            if (
              resStatusWip === statusWip ||
              resStatusCancelled === statusCancelled ||
              resStatusCompleted === statusCompleted
            ) {
              return (
                <Button className="link" onClick={() => handlerClick()}>
                  <Image
                    className="history-icon"
                    src={ICONS['icon-schematic.svg']}
                    alt="Project Details"
                    tootipValue={`Project Details`}
                    useTootipFor="Project Details"
                    useTootip={true}
                  />
                </Button>
              )
            } else {
              return ''
            }
          }
          return listRFQ.map((e, i) => {
            return (
              <Table.TR key={i}>
                <Table.TD className="w-200">
                  <Text
                    tootipValue={e.project_no}
                    useTootipFor="project-no"
                    useTootip={true}
                  >
                    {e.project_no}
                  </Text>
                </Table.TD>
                <Table.TD>
                  <Text
                    tootipValue={e.name}
                    useTootipFor="project-name"
                    useTootip={true}
                  >
                    {e.name}
                  </Text>
                </Table.TD>
                <Table.TD className="text-center w-250">
                  <div>{funcStartDate(e)}</div>
                </Table.TD>
                <Table.TD className="text-center w-180">
                  {funcActiveStatus(e)}
                </Table.TD>
                <Table.TD className="w-200 text-center">
                  <Text
                    tootipValue={e.created_by}
                    useTootipFor="project-by"
                    useTootip={true}
                  >
                    {e.created_by}
                  </Text>
                </Table.TD>
                <Table.TD className="actions w-180">
                  <Section>
                    {actionsEdit(e)}
                    {renderSchematicButton(e)}
                    {renderHistoryButton(e)}
                    {editRoleDetail !== false && funcDelete(e)}
                  </Section>
                </Table.TD>
              </Table.TR>
            )
          })
        }
      }
      const resultFound = () => {
        if (isEmpty(listRFQ)) {
          return (
            <Table.TBODY>
              <Table.TR>
                <Table.TD>
                  <Section className="no-result-found">
                    <Image src={ICONS['icon-ssr.png']} className="no-result" />
                    <p>No result found</p>
                  </Section>
                </Table.TD>
              </Table.TR>
            </Table.TBODY>
          )
        }
      }
      const showinglistRFQItem = () => {
        if (isEmpty(listRFQ)) {
          return '0'
        } else {
          if (resultRFQ.offset === 0) {
            return '1'
          } else {
            return resultRFQ.offset + 1
          }
        }
      }
      const showinglistRFQItemLimit = () => {
        const limit = resultRFQ.offset + resultRFQ.limit
        if (limit > resultRFQ.total_record) {
          return resultRFQ.total_record
        } else {
          return limit
        }
      }
      const onChangeNumberFormat = e => {
        return this.setState({
          searchPage: parseInt(e.target.value),
        })
      }
      const isAllowedNumberFormat = values => {
        const { value, floatValue } = values
        if (value == 0 && value !== '') {
          return false
        } else if (
          typeof floatValue === 'undefined' ||
          typeof value === 'undefined'
        ) {
          return true
        } else if (value.charAt(0) === '0') {
          if (value.charAt(1) && value.charAt(1) != '.') {
            return false
          }
        } else if (this.props.maximum) {
          return floatValue <= this.props.maximum
        } else {
          return true
        }
      }
      const onClickGo = e => {
        return this.changePage(this.state.searchPage)
      }
      const onChangePaginate = e => {
        return this.changePage(e)
      }
      const renderDateFrom = () => {
        const { isErrMsgStartDate } = this.state
        const handlerOnChange = date => {
          const startDate = date
          if (this._isMounted) {
            if (startDate === null) {
              store.dispatch(filterDateFrom('', true))
              this.setState({
                startDate: '',
              })
            } else {
              store.dispatch(filterDateFrom(startDate, true))
              this.setState({
                startDate,
              })
            }
          }
        }
        return (
          <Section
            className={`date_sourcing_projects form-group date-period ${
              isErrMsgStartDate ? 'is-error' : ''
            }`}
          >
            <DatePickerInput
              selected={this.state.startDate}
              onChange={handlerOnChange}
              selectsStart
              showMonthDropdown
              showYearDropdown
              dateFormat="MMM d, yyyy"
              dropdownMode="select"
              placeholderText="Create Date From"
              startDate={this.state.startDate}
            />
            {isErrMsgStartDate ? (
              <Section className="message">
                Start date must be after current time
              </Section>
            ) : (
              ''
            )}
          </Section>
        )
      }
      const renderDateTo = () => {
        const { isErrMsgEndDate } = this.state
        const handlerOnChange = date => {
          const endDate = date
          if (this._isMounted) {
            if (endDate === null) {
              store.dispatch(filterDateTo('', true))
              this.setState({ endDate: '' })
            } else {
              store.dispatch(filterDateTo(endDate, true))
              this.setState({ endDate })
            }
          }
        }
        return (
          <Section
            className={`date_sourcing_projects form-group date-period ${
              isErrMsgEndDate ? 'is-error' : ''
            }`}
          >
            <DatePickerInput
              selected={this.state.endDate}
              onChange={handlerOnChange}
              selectsEnd
              showMonthDropdown
              showYearDropdown
              dateFormat="MMM d, yyyy"
              dropdownMode="select"
              placeholderText="Create Date To"
              endDate={this.state.endDate}
              minDate={this.state.startDate}
            />
            {isErrMsgEndDate ? (
              <Section className="message">
                End date must be after current time
              </Section>
            ) : (
              ''
            )}
          </Section>
        )
      }
      return (
        <Section className="main-content">
          <Section className="content-body">
            <Section className="table-filter">
              <InputSearch
                id="filter_search_input"
                placeholder="Project No, Project Name"
                name="searchValue"
                clear={'true'}
                onKeyDown={funcOnKeyDownSearchInput}
                onChange={funcOnChangeSearchInput}
                onClickSearchClear={funconClickSearchSearchInput}
                value={this.props.searchSourcingInput}
              />
              <SelectBox
                id="even_status_filter"
                className="table-filter"
                options={this.state.optionsProjectStatus}
                isSearchable={false}
                isClearable={false}
                value={this.matchValueSelected(
                  this.state.optionsProjectStatus,
                  this.props.filterStatus
                )}
                onChange={funcOnChangeEventStatusFilter}
              />
              {renderDateFrom()}
              {renderDateTo()}
              <SelectBox
                id="create_status_filter"
                className="table-filter"
                options={buyerList}
                placeholder="Created By"
                isSearchable={false}
                isClearable={false}
                value={this.matchValueSelected(
                  buyerList,
                  this.props.searchOptionSourcingFilter4
                )}
                onChange={funcOnChangeCreateStatusFilter}
              />
            </Section>
            <Section mt={'3rem'} className="table-responsive">
              <Table className="table-souring table-default">
                {/* Header Row */}
                <Table.THEAD>
                  <Table.TR>
                    <Table.TH className="w-200" id="project_no">
                      <div>PROJECT NO.</div>
                    </Table.TH>
                    <Table.TH id="project_name">
                      <div>PROJECT NAME</div>
                    </Table.TH>
                    <Table.TH className="text-center w-250" id="create_date">
                      <div>CREATE DATE</div>
                    </Table.TH>
                    <Table.TH className="text-center w-180" id="status">
                      <div>STATUS</div>
                    </Table.TH>
                    <Table.TH className="w-200 text-center" id="created_by">
                      <div>CREATED BY</div>
                    </Table.TH>
                    <Table.TH className="actions w-180" id="actions_header">
                      <div>ACTIONS</div>
                    </Table.TH>
                  </Table.TR>
                </Table.THEAD>
                <Table.TBODY>{funcListRFQ()}</Table.TBODY>
                {resultFound()}
              </Table>
            </Section>
          </Section>
          <Section className="content-footer">
            <Section className="showing-item">
              {`Showing ${formatNumberWithComma(
                showinglistRFQItem()
              )} to ${formatNumberWithComma(
                showinglistRFQItemLimit()
              )} of ${formatNumberWithComma(resultRFQ.total_record)} entries`}
            </Section>
            <Section className="paginate-wrapper">
              <Paginate
                activePage={activePage ? activePage : 1}
                itemsCountPerPage={resultRFQ.limit}
                totalItemsCount={resultRFQ.total_record}
                onChange={onChangePaginate}
              />
              <Section className="moveto-wrapper">
                <NumberFormat
                  value={this.state.searchPag}
                  label="Page"
                  isHorizontal
                  className="paginate-moveto"
                  defaultValue="1"
                  maxLength="4"
                  customInput={Input}
                  decimalSeparator={false}
                  allowNegative={false}
                  allowLeadingZeros={false}
                  onChange={onChangeNumberFormat}
                  isAllowed={isAllowedNumberFormat}
                />
                <Button
                  disabled={
                    parseInt(this.state.searchPage) <=
                    parseInt(resultRFQ.total_page)
                      ? false
                      : true
                  }
                  onClick={onClickGo}
                >
                  go
                </Button>
              </Section>
            </Section>
          </Section>
        </Section>
      )
    }
    const modalDelete = () => {
      const handlerClickCancel = e => {
        document.body.classList.remove('modal-open')
        return this.toggleModal('delete')
      }
      const handlerClickConfirm = e => {
        if (!e.detail || e.detail === 1) {
          return this.onClickDelete(modals[0].sourcing_id)
        }
      }
      return (
        <Modal
          id="delete_id"
          className="theme-blue"
          isOpen={
            modals
              .filter(modal => {
                return modal.name === 'delete'
              })
              .map(obj => obj.isOpen)[0]
          }
          modalWidth="575px"
        >
          <Modal.Header>Delete</Modal.Header>
          <Modal.Body>
            <p className="default text-center">
              Are you sure to delete? <br />
              {modals[0].FullName}
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              id="close_modal_history_id"
              className="theme-border-gray"
              onClick={handlerClickCancel}
            >
              Cancel
            </Button>
            <Button
              id="close_modal_history_id"
              className="theme-green"
              onClick={handlerClickConfirm}
            >
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>
      )
    }
    const modalHistoryLog = () => {
      const funcIsOpen = () => {
        const result = modals
          .filter(modal => {
            return modal.name === 'history'
          })
          .map(obj => obj.isOpen)[0]
        return result
      }
      const isOpenModal = funcIsOpen()
      const handlerOnClickHistory = e => {
        return this.onCloseModalHistory()
      }
      return (
        <Modal
          id="history_log"
          className="history-log theme-blue"
          isOpen={isOpenModal}
        >
          <Modal.Header>History Log</Modal.Header>
          <Modal.Body>
            {this.state.loaderHistory ? (
              <Spinner />
            ) : (
              <Section className="table-header-freeze-wrapper">
                <Table className="history-log-data">
                  <Table.TBODY>
                    <Table.TR>
                      <Table.TH className="create-date">DATE</Table.TH>
                      <Table.TH className="detail">ACTIVITY</Table.TH>
                      <Table.TH className="action">ACTION BY</Table.TH>
                    </Table.TR>
                  </Table.TBODY>
                </Table>
                <Table className="history-log-data split-row-color">
                  <Table.TBODY>
                    {this.renderProjectHistories(
                      this.state.projectListHistoies
                    )}
                  </Table.TBODY>
                </Table>
              </Section>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              id="close_modal_history_id"
              className="theme-border-gray close"
              onClick={handlerOnClickHistory}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )
    }
    return (
      <React.Fragment>
        <SourcingProjectsStyled>
          {pageTitle()}
          {renderPageContent()}
        </SourcingProjectsStyled>
        {modalDelete()}
        {modalHistoryLog()}
      </React.Fragment>
    )
  }
  render = () => this.renderSourcingList()
}

const mapStateToProps = state => {
  const { data: dataReqSeal } = state.resultStartApiReqUnseal
  const { data: dataReqSealTec } = state.resultStartApiReqUnsealTec
  const { date: dateFrom } = state.getFilterDateFrom
  const { date: dateTo } = state.getFilterDateTo
  const { page: page } = state.getFilterPage
  const { status: filterStatus } = state.getStatusSourcingProjects
  const {
    searchSourcingInput,
    enterSearchSourcingFilter,
  } = state.searchInputFilterSourcing
  const {
    searchOptionSourcingFilter2,
    selectedSourcingOptions2,
  } = state.searchSelectOptionSourcing2
  const {
    searchOptionSourcingFilter3,
    selectedSourcingOptions3,
  } = state.searchSelectOptionSourcing3
  const {
    searchOptionSourcingFilter4,
    selectedOptionsSourcing4,
  } = state.searchSelectOptionSourcing4
  const {
    searchOptionSourcingFilter5,
    selectedOptionsSourcing5,
  } = state.searchSelectOptionSourcing5
  return {
    role: state.role,
    user: state.user,
    searchSourcingInput,
    enterSearchSourcingFilter,
    searchOptionSourcingFilter2,
    selectedSourcingOptions2,
    searchOptionSourcingFilter3,
    selectedSourcingOptions3,
    searchOptionSourcingFilter4,
    selectedOptionsSourcing4,
    searchOptionSourcingFilter5,
    selectedOptionsSourcing5,
    messageReqUnseal: dataReqSeal,
    messageReqUnsealTec: dataReqSealTec,
    dateFrom,
    dateTo,
    page,
    filterStatus,
  }
}

const SourcingProjectsContainer = connect(mapStateToProps)(
  SourcingProjectsContainers
)

export { SourcingProjectsContainer }

export default SourcingProjectsContainer
